import React from 'react';
import { Platform, StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { IconLink, useResponsive } from '@garnish/core';

import { type HeaderRightProps } from '../../Header.props';

export const HeaderRight = (props: HeaderRightProps) => {
  const { items = [], close, testID, tintColor } = props;

  const { currentBreakpoint } = useResponsive();

  const shouldRenderCloseBtn = currentBreakpoint.isXS && close !== undefined;
  const shouldRenderHeader = shouldRenderCloseBtn || items.length > 0;

  if (!shouldRenderHeader) return null;

  return (
    <View testID={testID} style={styles.headerRight}>
      {shouldRenderCloseBtn ? (
        <IconLink
          testID={close.testID ?? testID?.concat('.close')}
          width={36}
          height={36}
          name="IconClose"
          palette="muted"
          accessibilityRole="button"
          accessibilityLabel={close.accessibilityLabel}
          accessibilityHint={close.accessibilityHint}
          onPress={close.onPress}
          color={tintColor}
        />
      ) : null}

      {items.map(({ key, ref, icon, ...rest }) => (
        <IconLink
          key={key}
          ref={ref}
          name={icon}
          accessibilityRole="button"
          color={tintColor}
          {...rest}
        />
      ))}
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const headerSidePadding = Platform.OS === 'web' ? theme.spacing['4'] : 0;

const styles = StyleSheet.create({
  headerRight: {
    flexDirection: 'row-reverse',
    columnGap: theme.spacing['6'],
    paddingRight: headerSidePadding,
    marginRight: Platform.select({
      ios: -theme.spacing['1'],
      default: 0,
    }),
  },
});
